// A small, reverent pull-quote used to scatter saintly words across the site.
// tone: "gold" (Marian, default) or "crimson" (the Christos wing).
const TONES = {
  gold: { frame: "border-gold/40 bg-paleblue/30", mark: "text-gold/25", body: "text-midnight", author: "text-gold" },
  crimson: { frame: "border-crimson/30 bg-crimson/[0.04]", mark: "text-crimson/20", body: "text-wine", author: "text-crimson" },
};

export const MarianQuote = ({ text, author, source, url, kind, tone = "gold", testid = "marian-quote" }) => {
  const t = TONES[tone] || TONES.gold;
  const Body = kind === "paraphrase" ? "div" : "blockquote";
  return (
    <aside data-testid={testid} className="mx-auto max-w-7xl px-4 py-10 sm:px-8 lg:px-16">
      <figure className={`relative overflow-hidden rounded-3xl border px-6 py-8 sm:px-12 sm:py-12 ${t.frame}`}>
        {kind !== "paraphrase" && <span aria-hidden="true" className={`pointer-events-none absolute -left-2 -top-6 select-none font-serif text-[7rem] leading-none sm:text-[9rem] ${t.mark}`}>&ldquo;</span>}
        <Body className="relative">
          <p data-testid={`${testid}-text`} className={`font-serif text-xl italic leading-relaxed sm:text-2xl ${t.body}`}>{text}</p>
        </Body>
          <figcaption data-testid={`${testid}-citation`} className={`mt-5 font-mono text-[10px] uppercase tracking-[0.28em] ${t.author}`}>
            {author}{kind === "paraphrase" && " · Editorial paraphrase"}{source ? <span className="text-slateblue"> · {url ? <a data-testid={`${testid}-source`} href={url} target="_blank" rel="noreferrer" className="underline underline-offset-4 transition-colors hover:text-marian">{source}</a> : source}</span> : null}
          </figcaption>
      </figure>
    </aside>
  );
};
